import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { default as config } from '../../../utilities/config';

import { Button, Card, Combobox, Input } from '@salesforce/design-system-react';

import { ProfileMetadataEditor } from '../';

import './ProfileLookerUpper.scss';

class ProfileLookerUpper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      subscriberId: '',
      selection: []
    };
  }

  componentDidMount() {
    this.props.actions.fetchBlocks();
  }

  loadProfile() {
    if (this.state.subscriberId && this.state.subscriberId.length > 0) {
      this.props.actions.fetchProfile(this.state.subscriberId);
    } else {
      this.props.actions.receiveProfile({});
    }
  }

  handleTextChange(event, { value }) {
    this.setState({
      ...this.state,
      subscriberId: value
    });
  }

  handleKeyPress(event) {
    if (event.key === 'Enter') {
      this.loadProfile();
    }
  }

  removeIds(profile) {
    const scrubbedProfile = { ...profile };
    scrubbedProfile.tags = scrubbedProfile.tags.map(tag => ({
      tagType: tag.tagType,
      tagValue: tag.tagValue
    }));
    return scrubbedProfile;
  }

  handleSaveProfile() {
    if (this.state.subscriberId && this.state.subscriberId.length) {
      this.props.actions.saveProfile(
        this.state.subscriberId,
        this.removeIds(this.props.profileData.profile)
      );
    }
  }

  dirty() {
    return (
      Object.keys(this.props.profileData.profile).length > 0 &&
      JSON.stringify(this.props.profileData.profile) !==
        JSON.stringify(this.props.profileData.loaded)
    );
  }

  renderProfileEditor(profile) {
    if (profile && Object.keys(profile).length > 0) {
      return (
        <ProfileMetadataEditor profile={profile} actions={this.props.actions} />
      );
    }
    return null;
  }

  renderProfile(profile) {
    if (profile && Object.keys(profile).length > 0) {
      return (
        <div>
          Profile:
          <pre className="profile-data">
            {JSON.stringify(this.removeIds(profile), null, 2)}
          </pre>
        </div>
      );
    }
    return null;
  }

  blockOptions() {
    return (this.props.profileData.blocks || []).map(block => ({
      id: block.block_id,
      label: block.asset_type,
      value: block.block_id
    }));
  }

  renderSelectionLink(profile) {
    if (this.state.selection && this.state.selection.length > 0) {
      if (profile && Object.keys(profile).length > 0) {
        const blockId = this.state.selection[0].value;
        let host = config.serverUrl['ecruBear'];
        if (host === '/') {
          host = `${window.location.protocol}//${window.location.hostname}/`;
        }

        const data = {
          subscriber_id: profile.addresses?.[0]?.address,
          subscriber_key: profile.addresses?.[0]?.address,
          context: 'SEND',
          job_id: '1234',
          image: 'true',
          explain: 'true'
        };
        const qs = Object.entries(data)
          .map(entry => `${entry[0]}=${entry[1]}`)
          .join('&');
        const selectionLink = `${host}einstein/api/block/${blockId}/selection?${qs}`;
        //profile and block selected, show selection link
        return (
          <div>
            Selection Link:
            <pre className="selection-link profile-data">{selectionLink}</pre>
          </div>
        );
      }
    }
    return null;
  }

  render() {
    const { profile } = this.props.profileData;
    const subscriberIdEmpty =
      !this.state.subscriberId || !this.state.subscriberId.length;
    return (
      <div>
        <Card heading="Profile Browser">
          <div className="profile-looker-upper">
            <div className="profile-input">
              <div className="filters">
                <div className="profile-input-row">
                  <Input
                    className="subscriber-input"
                    label="Subscriber Id"
                    value={this.state.subscriberId}
                    onChange={this.handleTextChange.bind(this)}
                    onKeyPress={this.handleKeyPress.bind(this)}
                  />
                  <Button
                    variant="brand"
                    label="Load"
                    disabled={subscriberIdEmpty}
                    onClick={this.loadProfile.bind(this)}
                  />
                  <Button
                    label="Save"
                    variant="brand"
                    disabled={!this.dirty()}
                    onClick={this.handleSaveProfile.bind(this)}
                  />
                </div>
                <div className="block-input">
                  <Combobox
                    labels={{
                      label: 'Block'
                    }}
                    options={this.blockOptions()}
                    selection={this.state.selection}
                    events={{
                      onSelect: (evt, { selection }) => {
                        this.setState({
                          subscriberId: this.state.subscriberId,
                          selection
                        });
                      }
                    }}
                    variant="readonly"
                  />
                </div>
              </div>
              <div className="editor">{this.renderProfileEditor(profile)}</div>
            </div>
            <div className="profile-output">
              {this.renderSelectionLink(profile)}
              {this.renderProfile(profile)}
            </div>
          </div>
        </Card>
      </div>
    );
  }
}

ProfileLookerUpper.propTypes = {
  profileData: PropTypes.object,
  actions: PropTypes.object,
  location: PropTypes.object
};

export default injectIntl(ProfileLookerUpper);
